module.exports = __webpack_public_path__ + "static/media/lol5.c7cfb15a.PNG";